import { render } from "./chat-index.vue?vue&type=template&id=77944aea"
import script from "./chat-index.vue?vue&type=script&lang=js"
export * from "./chat-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__